import {combineReducers} from 'redux'
import {routerReducer as router} from 'react-router-redux'
import {reducer as form} from 'redux-form'
import { loadingBarReducer } from 'react-redux-loading-bar'
import appReducer, {moduleName as appModule} from '../modules/app'
import profileReducer, {moduleName as profileModule} from '../modules/profile'
import questionsReducer, {moduleName as questionsModule} from '../modules/questions'
import supportReducer, {moduleName as supportModule} from '../modules/support'
import modalsReducer, {moduleName as modalsModule} from '../modules/modals'
import {moduleName as subjectsModule, reducer as subjectsReducer} from '../modules/subjects'
import {moduleName as categoriesModule, reducer as categoriesReducer} from '../modules/categories'
import {moduleName as sourcesModule, reducer as sourcesReducer} from '../modules/sources'
import tutorialReducer, {moduleName as tutorialModule} from '../modules/tutorial'
import {moduleName as usersModule, usersReducer} from  '../modules/users'
import {reducer as toastrReducer} from 'react-redux-toastr'
import loadCursore from './reducers/loadCursore'
import rooms from './reducers/rooms'
import students from './reducers/students'
import folders from './reducers/folders'
import statistic_report from './reducers/statistic_report'
import presentation from './reducers/presentation'
import payment from './reducers/payment'
import teacher from './reducers/teacher'
import card from './reducers/card'
import label from './reducers/label'
import question from './reducers/question'

export default combineReducers({
    router,
    form,
    [appModule]: appReducer,
    [profileModule] : profileReducer,
    [questionsModule] : questionsReducer,
    [supportModule] : supportReducer,
    [modalsModule] : modalsReducer,
    [subjectsModule] : subjectsReducer,
    [categoriesModule] : categoriesReducer,
    [sourcesModule] : sourcesReducer,
    [tutorialModule] : tutorialReducer,
    loadingBar : loadingBarReducer,
    [usersModule] : usersReducer,
    toastr: toastrReducer,
    loadCursore,
    rooms,
    students,
    statistic_report,
    folders,
    presentation,
    payment,
    teacher,
    card,
    label,
    question,
})



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/redux/reducer.js